import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  templateUrl: './timepicker.component.html',
  styleUrl: './timepicker.component.scss',
  selector: 'app-timepicker',
})
export class TimepickerComponent {
  @Input() disabled: boolean = false;
  @Input() label: string = '';
  @Input() value: string | null = null;
  @Output() valueChange = new EventEmitter<string>();

  public dropdownOptions: { label: string; value: string }[] = [
    { label: '5:00 AM', value: '5:00' },
    { label: '6:00 AM', value: '6:00' },
    { label: '7:00 AM', value: '7:00' },
    { label: '8:00 AM', value: '8:00' },
    { label: '9:00 AM', value: '9:00' },
    { label: '10:00 AM', value: '10:00' },
    { label: '11:00 AM', value: '11:00' },
    { label: '12:00 PM', value: '12:00' },
    { label: '1:00 PM', value: '13:00' },
    { label: '2:00 PM', value: '14:00' },
    { label: '3:00 PM', value: '15:00' },
    { label: '4:00 PM', value: '16:00' },
    { label: '5:00 PM', value: '17:00' },
    { label: '6:00 PM', value: '18:00' },
    { label: '7:00 PM', value: '19:00' },
    { label: '8:00 PM', value: '20:00' },
    { label: '9:00 PM', value: '21:00' },
    { label: '10:00 PM', value: '22:00' },
  ];

  public onValueChange(value: string): void {
    this.valueChange.emit(value);
  }
}
